import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDropbox = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_336_9508)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M11.999 5.10934L18.5248 9.0015L22.9999 5.54109L16.5274 1.45825L11.999 5.10934Z",
				fill: "#1976D2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 5.11117L7.47167 1.45825L1 5.54017L5.47608 9.00242L12 5.11117Z",
				fill: "#1976D2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 12.8946L16.5274 16.5456L23 12.4637L18.5239 9.00146L12 12.8936L5.47425 9.00146L1 12.4637L7.47167 16.5456L12 12.8946Z",
				fill: "#1976D2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.876 18.588V16.64L16.8556 17.9142V17.9151C16.0966 18.3982 15.7511 17.4238 12.001 14.6133C8.18673 17.4806 7.90073 18.39 7.14448 17.9142L5.12598 16.641V18.588L12.0147 22.5415L18.876 18.588Z",
				fill: "#1976D2"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_336_9508",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 22,
			height: 22,
			fill: "white",
			transform: "translate(1 1)"
		})
	}) })]
});
export default SvgDropbox;
